import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material';
import { useNotify } from 'react-admin';

export const SecretDialog = ({ open, secret, message, onClose }) => {
  const notify = useNotify();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      notify('Secret copied', { type: 'info' });
    } catch {
      notify('Failed to copy the secret', { type: 'error' });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Bridge secret</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{message}</DialogContentText>
        <TextField
          fullWidth
          value={secret || ''}
          InputProps={{ readOnly: true, sx: { fontFamily: 'monospace' } }}
        />
      </DialogContent>
      <DialogActions>
        <MuiButton onClick={handleCopy} color="primary">Copy</MuiButton>
        <MuiButton onClick={onClose} color="primary">Close</MuiButton>
      </DialogActions>
    </Dialog>
  );
};
